import baseContainer from './_baseContainer';
import SteppedPathways from '../components/view/SteppedPathways/SteppedPathways';

const mapStateToProps = (state) => {
  return {
    token: state?.auth?.authentication || undefined,
  };
};

const mapDispatchToProps = () => ({
});

export default baseContainer(mapStateToProps, mapDispatchToProps)(SteppedPathways);
